AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Models", "Quest");

AoPS.Alcumus.Models.Quest = (function () {
	// Dependencies
	var AlcMBase = AoPS.Alcumus.Models.Base;
	var AlcMQuestLevel = AoPS.Alcumus.Models.QuestLevel;

	// Note that there is only one of these models per quest type.
	return AlcMBase.BaseModel.extend({
		id_attribute: "quest_id",
		defaults: {
			is_achievement: false,
			order: 0,
			level_count: 1,
			times_completed: 0,
			best_level: 0,
			is_assigned: false, // True if any QuestLevel models are assigned
		},
		/** Additional attributes:
			user: User model owning this one; guaranteed to be set
			level: Collection of QuestLevel models
		*/

		initialize: function () {
			this.set("levels", new AlcMBase.BaseCollection());
			this.get("levels").setCreateFunction(
				_.bind(function (id) {
					return new AlcMQuestLevel({
						id: id,
						quest: this,
						user: this.get("user"),
					});
				}, this)
			);
			this.get("levels").comparator = "id";

			this.listenTo(this.get("levels"), "change:is_assigned", function () {
				this.set("is_assigned", !!this.getAssigned());
			});
		},

		requestLoad: function (callback, context) {
			this.get("user").requestQuestsLoad(callback, context);
		},

		// unpack behaves a bit strangely for this model. The back-end will send
		// user quest objects / unfinished levels to be unpacked. These contain
		// fields across the front-end Quest and QuestLevel models. The Quest
		// model's unpack method is responsible for figuring out how to assign
		// these and use the sent data to create QuestLevel models.
		unpack: function (data) {
			if (!data) {
				return;
			}

			this.setFields(data);

			var level_model;
			var curr_uq_id;
			var matching_id;
			if (data.level) {
				level_model = this.get("levels").getOrCreate(parseInt(data.level, 10));
				// There is a possibility that we will unpack multiple quests
				// into the same level model. Assigned, completed, failed, repeats...
				// These need to merge smoothly, which is unfortunately complicated.
				// We do checks on the user_quest_id to figure out how to do this.

				curr_uq_id = parseInt(level_model.get("user_quest_id"));
				// matching_id being true means this quest has data relevant to
				// the most recently assigned/completed iteration.
				matching_id = curr_uq_id && curr_uq_id === parseInt(data.user_quest_id);

				if (data.is_completed && !matching_id) {
					// Data about the quest completed in the past. If assigned now,
					// don't overwrite any of that data.
					data = _.omit(data, ["is_assigned", "available_at", "progress"]);
				} else if (data.is_failed && curr_uq_id && !matching_id) {
					// Data about the quest being failed in a past iteration. Ignore.
					data = null;
				} else if (data.is_assigned || data.is_failed) {
					// Data about a current version of the quest. Don't overwrite
					// any data about completion.
					data = _.omit(data, ["is_completed", "finished_at", "xp_bonus"]);
				}
				// If the model already has a user quest ID, only being assigned the
				// quest can override that.
				if (curr_uq_id && data && !data.is_assigned) {
					delete data.user_quest_id;
				}

				// If neither assigned or completed, we shouldn't be overwriting
				// an existing model, so no need to do anything.
				level_model.unpack(data);
			}
		},

		setFields: function (data) {
			// Make full set of raw values; we'll prune this list below.
			var set_data = {
				is_achievement: !!data.is_achievement,
				// Make it easier on collection comparators by breaking ties on order by id.
				order:
					10000 * parseInt(data.order, 10) || 0 + parseInt(this.id, 10) || 0,
				level_count: parseInt(data.level_count, 10),
				times_completed: parseInt(data.times_completed, 10),
				best_level: parseInt(data.best_level, 10),
			};
			// Don't update any fields that weren't actually sent to us
			_.each(set_data, function (val, key) {
				if (!data.hasOwnProperty(key)) {
					delete set_data[key];
				}
			});

			this.set(set_data);
		},

		// Get times that the best level is completed. (The times_completed value
		// loaded counts all levels.)
		getBestLevelCompletedCount: function () {
			var best_level = this.get("best_level");
			return best_level ? this.get("times_completed") - best_level + 1 : 0;
		},

		// Get the models to show views for on the full list of quests.
		getListModels: function () {
			var levels = this.get("levels");
			var best_level = this.get("best_level");

			var best_complete = levels.get(best_level);

			var first_incomplete = this.getAssigned();
			if (first_incomplete && best_complete === first_incomplete) {
				first_incomplete = null;
			} else if (!first_incomplete && this.get("is_achievement")) {
				first_incomplete = levels.get(best_level + 1);
			} else if (!first_incomplete && !best_complete) {
				first_incomplete = levels.get(1);
				if (first_incomplete && first_incomplete.get("is_failed")) {
					first_incomplete = null;
				}
			}

			return _.compact([best_complete, first_incomplete]);
		},

		getAssigned: function () {
			return this.get("levels").findWhere({is_assigned: true});
		},
	});
})();
